import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "filters" }
const _hoisted_3 = { class: "content-input" }
const _hoisted_4 = {
  class: "dropdown-button input-dropdown input-border",
  type: "button"
}
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("label", { class: "label" }, "Select Project", -1)),
        _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
          control: _withCtx(() => [
            _createElementVNode("label", _hoisted_4, _toDisplayString($setup.displaySelectedTitle), 1)
          ]),
          dropdown: _withCtx(() => [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: option.id,
                  onClick: () => $setup.setSelectedEstate(option),
                  class: _normalizeClass({ 'dropdown__item-active': option.id === $setup.selectedEstateId })
                }, _toDisplayString(option.title), 11, _hoisted_5))
              }), 128))
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}